module.exports = __webpack_public_path__ + "static/media/LC.78602fd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LC.svg
// module id = 2195
// module chunks = 7